import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/machines/_layout/')({
  component: () => null,
});
